<template>
  <div>
    <div class="container-center-horizontal">
      <contact-form />
    </div>
  </div>
</template>

<script>
import './styleguide.css'
import ContactForm from './ContactForm.vue';


export default {
  metaInfo: {
    title: 'Contact Us – Djuli',
    meta: [
      { name: 'description', content: 'Get in touch with the Djuli team. Request a trial, demo, or support for your sensor data analysis needs.' },
      { property: 'og:title', content: 'Contact Us – Djuli' },
      { property: 'og:url', content: 'https://dju.li/contact' },
      { property: 'og:type', content: 'website' },
    ],
  },
  components: { ContactForm },
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  },
};

</script>

<style scoped></style>
